<lib-dlg titulo="Cadastro de Grupo de serviços" nome="dlgMaterialCad" styleClassHeader="text-white bg-primary"
  (onHide)="sair()" [visualizar]="visualizar">
  <form [formGroup]="entidadeForm" autocomplete="off">
    <div class="form-row">
      <div class="col-sm-12">
        <div class="form-row mt-2">
          <div class="form-group col-md-5">
            <div class="d-flex justify-content-between">
              <label for="codigo">Código<span class="text-danger">*</span></label>
              <span class="text-primary">#{{visualizaCodigo()}}</span>
            </div>
            <input #codigo_ id="codigo" formControlName="codigo" type="text" class="form-control">
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="nome">Nome<span class="text-danger">*</span></label>
            <input id="nome" formControlName="nome" type="text" class="form-control font-weight-bold">
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="sub_grupo">Sub-Grupo<span class="text-danger">*</span></label>
            <p-autoComplete formControlName="sub_grupo" [field]="subGrupoAutoComplete.conversor"
              [suggestions]="subGrupoAutoComplete.lista" (completeMethod)="subGrupoAutoComplete.filtrar($event)"
              placeholder="Informe o nome sub-grupo" inputStyleClass="form-control font-weight-bold" minLength="2"
              [style]="{ width: '100%' }" [forceSelection]="true" [autoHighlight]="true" *ngIf="subGrupoAutoComplete"
              appendTo="body" (onSelect)="selectSubGrupo()">
              <ng-template let-subGrupo pTemplate="item">
                {{subGrupo.codigo}} {{subGrupo.nome}}
              </ng-template>
            </p-autoComplete>
            <label *ngIf="entidadeForm.get('sub_grupo').value" style="color: #ef6c00"
              class="font-weight-bold small mt-2">
              {{ entidadeForm.get('sub_grupo').value['grupo']['nome'] }}
            </label>
          </div>
        </div>
        <div class="form-row p-1 pl-0 pr-0">
          <div class="col-sm-12">
            <div class="card p-3">
              <div class="form-row">
                <div class="col-sm-6">
                  <div class="checkbox checbox-switch switch-warning">
                    <label>
                      <input type="checkbox" formControlName="contabilizar" /><span></span>Contabilizar
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <ng-container opcoes>
    <button (click)="submitForm()" type="submit" class="btn btn-primary btn-sm float-right ml-2">Salvar</button>
  </ng-container>
</lib-dlg>